import { DateTimeRange } from '../types';
import { isMatchingPreset } from './isMatchingPreset';
import { getDateTimeRangeString } from './getDateTimeRangeString';

export function getSelectedDateRangeOption(
  value: DateTimeRange,
  options: DateTimeRange[],
): string {
  const timeRangeString = getDateTimeRangeString(value);
  if (!timeRangeString) {
    return 'Default';
  }
  const isPresetSelected = options.find((preset) =>
    isMatchingPreset(preset, value),
  );
  return isPresetSelected ? timeRangeString : 'custom';
}
